import {cloneSpinner} from '../../Library/LoadingIndicator';

const COOKIE_NAME = 'pdfDownloadComplete';
const POLL_INTERVAL_MS = 300;
const TIMEOUT_MS = 90000;

const cookiePresent = () => document.cookie
    .split(';')
    .some((cookie) => cookie.trim().startsWith(`${COOKIE_NAME}=`));

const clearCookie = () => {
    document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
};

const showProcessingState = (form) => {
    const dialog = form.closest('.form-modal');
    const submitButton = dialog?.querySelector(`button[type="submit"][form="${form.id}"]`);

    if (!submitButton) {
        return null;
    }

    const originalContent = submitButton.innerHTML;

    submitButton.disabled = true;
    submitButton.replaceChildren(cloneSpinner(), ` ${dialog.dataset.processingText}`);

    return () => {
        submitButton.disabled = false;
        submitButton.innerHTML = originalContent;
    };
};

export const handleCreatePdfSubmit = (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-create-pdf')) {
        return;
    }

    const restoreButton = showProcessingState(form);
    const downloadField = form.querySelector('input[name="download"]');
    const downloadRequested = downloadField === null || downloadField.checked;

    if (!downloadRequested) {
        return;
    }

    clearCookie();

    const startedAt = Date.now();

    const poll = setInterval(() => {
        if (cookiePresent()) {
            clearInterval(poll);
            clearCookie();
            window.location.reload();

            return;
        }

        if (Date.now() - startedAt > TIMEOUT_MS) {
            clearInterval(poll);
            restoreButton?.();
        }
    }, POLL_INTERVAL_MS);
};
